/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ComputeVolumeDataInput,
  ComputeVolumeDataInput$inboundSchema,
  ComputeVolumeDataInput$Outbound,
  ComputeVolumeDataInput$outboundSchema,
} from "./computevolumedatainput.js";

export type ComputeVolumeInput = {
  data?: Array<ComputeVolumeDataInput> | undefined;
  mountPath: string;
  sizeGb: number;
};

/** @internal */
export const ComputeVolumeInput$inboundSchema: z.ZodType<
  ComputeVolumeInput,
  z.ZodTypeDef,
  unknown
> = z.object({
  data: z.array(ComputeVolumeDataInput$inboundSchema).optional(),
  mount_path: z.string(),
  size_gb: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "mount_path": "mountPath",
    "size_gb": "sizeGb",
  });
});
/** @internal */
export type ComputeVolumeInput$Outbound = {
  data?: Array<ComputeVolumeDataInput$Outbound> | undefined;
  mount_path: string;
  size_gb: number;
};

/** @internal */
export const ComputeVolumeInput$outboundSchema: z.ZodType<
  ComputeVolumeInput$Outbound,
  z.ZodTypeDef,
  ComputeVolumeInput
> = z.object({
  data: z.array(ComputeVolumeDataInput$outboundSchema).optional(),
  mountPath: z.string(),
  sizeGb: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    mountPath: "mount_path",
    sizeGb: "size_gb",
  });
});

export function computeVolumeInputToJSON(
  computeVolumeInput: ComputeVolumeInput,
): string {
  return JSON.stringify(
    ComputeVolumeInput$outboundSchema.parse(computeVolumeInput),
  );
}
export function computeVolumeInputFromJSON(
  jsonString: string,
): SafeParseResult<ComputeVolumeInput, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ComputeVolumeInput$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ComputeVolumeInput' from JSON`,
  );
}
